/**
 * Collection Pagination - Infinite scroll loading for products
 */

// Get AJAX URL helper
function getAjaxUrl() {
    if (typeof collectionPagination !== 'undefined' && collectionPagination.ajax_url) {
        return collectionPagination.ajax_url;
    }
    if (typeof ajaxurl !== 'undefined') {
        return ajaxurl;
    }
    // Fallback: try to get from ajax_object (set by header.js)
    if (typeof ajax_object !== 'undefined' && ajax_object.ajax_url) {
        return ajax_object.ajax_url;
    }
    return '/wp-admin/admin-ajax.php';
}

document.addEventListener('DOMContentLoaded', () => {
    const collectionPage = document.querySelector('.page-template-template-collections');
    const collectionDetailPage = document.querySelector('.tax-pa_collection');
    const searchPage = document.querySelector('.search-results');
    
    if (!collectionPage && !collectionDetailPage && !searchPage) return;
    
    // Configuration
    const CONFIG = {
        perPage: 24,
        loadMoreSelector: '.js-load-more-products',
        productContainerSelector: '.l-collection-overview',
        loaderClass: 'is-loading',
        hiddenClass: 'is-hidden',
        scrollThreshold: 400 // Start loading when 400px from bottom
    };
    
    // State
    let currentPage = 1;
    let isLoading = false;
    let hasMore = true;
    let showCollections = false;
    let collectionId = 0;
    let totalProducts = 0;
    let isSearch = false;
    let searchTerm = '';
    let searchType = 'decor';
    
    // Initialize
    function init() {
        const loadMoreBtn = document.querySelector(CONFIG.loadMoreSelector);
        
        if (loadMoreBtn) {
            // Read initial state from data attributes
            currentPage = parseInt(loadMoreBtn.dataset.currentPage || 1, 10);
            hasMore = loadMoreBtn.dataset.hasMore === 'true';
            showCollections = loadMoreBtn.dataset.showCollections === 'true';
            collectionId = parseInt(loadMoreBtn.dataset.collectionId || 0, 10);
            isSearch = loadMoreBtn.dataset.isSearch === 'true';
            searchTerm = loadMoreBtn.dataset.searchTerm || '';
            searchType = loadMoreBtn.dataset.searchType || 'decor';
            
            // Calculate total from remaining count
            const remainingEl = loadMoreBtn.querySelector('.js-remaining-count');
            if (remainingEl) {
                const remaining = parseInt(remainingEl.textContent, 10) || 0;
                totalProducts = (currentPage * CONFIG.perPage) + remaining;
            }
            
            if (!hasMore) {
                loadMoreBtn.classList.add(CONFIG.hiddenClass);
            } else {
                // Setup infinite scroll
                setupInfiniteScroll();
            }
            
            // Also allow clicking as fallback
            loadMoreBtn.addEventListener('click', (e) => {
                e.preventDefault();
                loadMore();
            });
        }
    }
    
    /**
     * Get current filters from URL
     */
    function getFilters() {
        const params = new URLSearchParams(window.location.search);
        const filters = {};
        
        params.forEach((value, key) => {
            if (key.startsWith('filter_')) {
                filters[key] = value;
            }
        });
        
        return filters;
    }
    
    /**
     * Get collection ID from container or button
     */
    function getCollectionId() {
        if (collectionId > 0) return collectionId;
        
        const container = document.querySelector('[data-collection-id]');
        return container ? parseInt(container.dataset.collectionId, 10) : 0;
    }
    
    /**
     * Load more products
     */
    async function loadMore() {
        if (isLoading || !hasMore) return;
        
        const loadMoreBtn = document.querySelector(CONFIG.loadMoreSelector);
        
        isLoading = true;
        loadMoreBtn?.classList.add(CONFIG.loaderClass);
        
        try {
            const nextPage = currentPage + 1;
            console.log('Loading page', nextPage);
            
            const data = await fetchProducts(nextPage);
            
            if (data && data.success) {
                appendProducts(data.data.html);
                currentPage = nextPage;
                hasMore = data.data.has_more;
                totalProducts = data.data.total_products;
                
                // Update button state
                if (loadMoreBtn) {
                    loadMoreBtn.dataset.currentPage = currentPage;
                    loadMoreBtn.dataset.hasMore = hasMore;
                    
                    // Update count display
                    const countEl = loadMoreBtn.querySelector('.js-remaining-count');
                    if (countEl) {
                        const remaining = totalProducts - (currentPage * CONFIG.perPage);
                        countEl.textContent = Math.max(0, remaining);
                    }
                    
                    if (!hasMore) {
                        loadMoreBtn.classList.add(CONFIG.hiddenClass);
                    }
                }
            } else {
                console.error('Invalid response:', data);
                hasMore = false;
            }
        } catch (error) {
            console.error('Error loading products:', error);
            // Don't set hasMore to false on error, allow retry
        } finally {
            isLoading = false;
            loadMoreBtn?.classList.remove(CONFIG.loaderClass);
        }
    }
    
    /**
     * Fetch products from AJAX endpoint
     */
    async function fetchProducts(page) {
        const formData = new FormData();
        
        // Use different endpoint based on search type
        if (isSearch) {
            let action = 'load_search_products'; // default for decor
            
            if (searchType === 'project') {
                action = 'load_search_projects';
            } else if (searchType === 'blog') {
                action = 'load_search_blogs';
            }
            
            formData.append('action', action);
            formData.append('search', searchTerm);
            formData.append('search_type', searchType);
        } else {
            formData.append('action', showCollections ? 'load_collections' : 'load_collection_products');
            formData.append('collection_id', getCollectionId());
            formData.append('show_collections', showCollections ? 'true' : 'false');
        }
        
        formData.append('page', page);
        formData.append('per_page', CONFIG.perPage);

        if (typeof decolegnoAjax !== 'undefined' && decolegnoAjax.nonce) {
            formData.append('security', decolegnoAjax.nonce);
        }
        
        const filters = getFilters();
        Object.keys(filters).forEach(key => {
            formData.append(`filters[${key}]`, filters[key]);
        });
        
        console.log('Fetching from:', getAjaxUrl(), 'Type:', searchType, 'Search:', isSearch);
        
        const response = await fetch(getAjaxUrl(), {
            method: 'POST',
            body: formData,
            credentials: 'same-origin'
        });
        
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        
        return response.json();
    }
    
    /**
     * Append products to container - insert BEFORE the load more button
     */
    function appendProducts(html) {
        // Find appropriate container based on search type
        let container, loadMoreWrapper;
        
        if (searchType === 'project') {
            container = document.querySelector('.l-projects-overview');
            loadMoreWrapper = document.querySelector('.l-projects-overview__load-more');
        } else if (searchType === 'blog') {
            container = document.querySelector('.c-blog-cards--search');
            loadMoreWrapper = document.querySelector('.c-blog-cards__load-more');
        } else {
            container = document.querySelector(CONFIG.productContainerSelector);
            loadMoreWrapper = document.querySelector('.l-collection-overview__load-more');
        }
        
        if (!container || !html) return;
        
        // Create temp container to parse HTML
        const temp = document.createElement('div');
        temp.innerHTML = html;
        
        // Append each item with animation, insert before load more button
        const items = Array.from(temp.children);
        items.forEach((item, index) => {
            item.style.opacity = '0';
            item.style.transform = 'translateY(20px)';
            
            // Insert before load more wrapper if it exists, otherwise append
            if (loadMoreWrapper) {
                container.insertBefore(item, loadMoreWrapper);
            } else {
                container.appendChild(item);
            }
            
            // Trigger reflow for animation
            requestAnimationFrame(() => {
                item.style.transition = 'opacity 0.3s ease, transform 0.3s ease';
                item.style.transitionDelay = `${index * 30}ms`;
                item.style.opacity = '1';
                item.style.transform = 'translateY(0)';
            });
        });
        
        // Re-init any color bar click effects for new collection items
        initColorBarHovers();

        if (typeof window.decolegnoInitLazyImages === 'function') {
            window.decolegnoInitLazyImages(container);
        }

    }
    
    /**
     * Initialize color bar click effects (for collection items)
     */
    function initColorBarHovers() {
        const colorBars = document.querySelectorAll('.c-collection-item__colors-bar__item:not(.initialized)');
        
        colorBars.forEach(item => {
            item.classList.add('initialized');
            
            item.addEventListener('click', function() {
                const itemCollectionId = this.dataset.collectionId;
                const url = this.dataset.url;
                const srcset = this.dataset.srcset;
                
                // Update main image
                const itemContainer = document.querySelector(`#collection-${itemCollectionId}`);
                if (itemContainer) {
                    const mainImg = itemContainer.querySelector('.c-collection-item__image img');
                    if (mainImg) {
                        mainImg.src = url;
                        mainImg.srcset = srcset;
                    }
                }
                
                // Update active state
                const siblings = itemContainer?.querySelectorAll('.c-collection-item__colors-bar__item');
                siblings?.forEach(s => s.classList.remove('is-active'));
                this.classList.add('is-active');
            });
        });
    }
    
    /**
     * Setup infinite scroll using Intersection Observer
     */
    function setupInfiniteScroll() {
        const loadMoreBtn = document.querySelector(CONFIG.loadMoreSelector);
        if (!loadMoreBtn) return;
        
        // Use Intersection Observer for efficient scroll detection
        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting && !isLoading && hasMore) {
                    loadMore();
                }
            });
        }, {
            root: null, // viewport
            rootMargin: `${CONFIG.scrollThreshold}px`, // Load before reaching the button
            threshold: 0
        });
        
        observer.observe(loadMoreBtn);
        
        // Also add scroll listener as fallback for older browsers
        let scrollTimeout;
        window.addEventListener('scroll', () => {
            if (scrollTimeout) clearTimeout(scrollTimeout);
            
            scrollTimeout = setTimeout(() => {
                if (isLoading || !hasMore) return;
                
                const rect = loadMoreBtn.getBoundingClientRect();
                const viewportHeight = window.innerHeight;
                
                // Check if button is near viewport
                if (rect.top < viewportHeight + CONFIG.scrollThreshold) {
                    loadMore();
                }
            }, 100);
        }, { passive: true });
    }
    
    // Initialize
    init();
    initColorBarHovers();
});

/**
 * Update filter counts via AJAX (call this when filters change)
 */
async function updateFilterCounts(collectionId = 0) {
    const filters = {};
    const params = new URLSearchParams(window.location.search);
    
    params.forEach((value, key) => {
        if (key.startsWith('filter_')) {
            filters[key] = value;
        }
    });
    
    const formData = new FormData();
    formData.append('action', 'get_term_counts');
    formData.append('collection_id', collectionId);

    if (typeof decolegnoAjax !== 'undefined' && decolegnoAjax.nonce) {
        formData.append('security', decolegnoAjax.nonce);
    }
    
    Object.keys(filters).forEach(key => {
        formData.append(`filters[${key}]`, filters[key]);
    });
    
    try {
        const response = await fetch(getAjaxUrl(), {
            method: 'POST',
            body: formData,
            credentials: 'same-origin'
        });
        
        const data = await response.json();
        
        if (data.success) {
            updateFilterCountsUI(data.data);
        }
    } catch (error) {
        console.error('Error updating filter counts:', error);
    }
}

/**
 * Update filter counts in the UI
 */
function updateFilterCountsUI(termCounts) {
    Object.keys(termCounts).forEach(taxonomy => {
        const counts = termCounts[taxonomy];
        
        Object.keys(counts).forEach(termId => {
            const count = counts[termId];
            const input = document.querySelector(`#filter-tag-${termId}`);
            
            if (input) {
                const label = input.closest('.c-filter-item');
                if (label) {
                    // Update the count in the label text
                    const text = label.textContent;
                    const newText = text.replace(/\(\d+\)/, `(${count})`);
                    
                    // Find text node and update
                    const textNode = Array.from(label.childNodes).find(
                        node => node.nodeType === Node.TEXT_NODE
                    );
                    
                    if (textNode) {
                        textNode.textContent = newText.trim();
                    }
                }
            }
        });
    });
}
